module.exports = __webpack_public_path__ + "static/media/parenting.9fc04b24.png";